<template>
  <v-snackbar
    v-if="this.$store.state.error"
    v-model="snackbar"
    :timeout="0"
    color="error"
    top
  >
    {{ this.$store.state.error }}
    <v-btn dark icon @click.prevent="dismiss">
      <v-icon>
        far fa-times-circle
      </v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: "ErrorMessage",
  data() {
    return {
      snackbar: true,
    };
  },
  methods: {
    dismiss() {
      this.$store.state.error = "";
    },
  },
};
</script>
